var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-body"},[_c('div',{staticClass:"tab-body__container",style:({ 'max-width': _vm.containerMaxWidth })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }